<template>
    <div>
        <v-autocomplete
                id="filterText"
                v-model="selectedCustomer"
                :items="names"
                item-text="name"
                return-object
                @change="$emit('selected', selectedCustomer)"
                label="Search"
                prepend-icon="search"
                :rules="rules"
                placeholder="Customer Name...">
        </v-autocomplete>
    </div>
</template>

<script>
    import belit from '../Lib/Belit'

    export default {
        name: "CustomerDropdown",
        created() {
            this.getCustomerNames();
            console.log("customerDropCreated", this.customer_id)
        },
        computed: {
        },
        data() {
            return {
                selectedCustomer: null,
                names: [],
            }
        },
        props:{
            customer_id:{
                default:null,
            },
            rules: {
                default: () => {return []},
            }
        },
        watch :{
            customer_id(v){
                if(v){
                    this.setCustomer();
                }
            },
            selectedCustomer(v){
                if(!v && this.customer_id){
                    this.setCustomer();
                }
            }
        },
        methods: {
            async getCustomerNames() {
                try{
                    let customerNames = await belit.get('/names/active');
                    if (customerNames) {
                        this.names = customerNames.data;
                        if(this.customer_id){
                            this.setCustomer();
                        }
                    }
                }catch(error){
                    console.log(error, 'If 401, it is sending the wrong API token, or a bad token.')
                }
            },
            setCustomer(){
                console.log("setCustomer ran", this.customer_id);
                let customer = this.names.filter(a => {return a.customer_id === this.customer_id})
                if(customer.length > 0){
                    this.selectedCustomer = customer[0];
                }
            }
        }
    }
</script>

<style scoped>

</style>
